var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accounting-year-status-label",class:{
        'processing': _vm.value === 0,
        'settlementting': _vm.value === 1,
        'closed': _vm.value === 2,
    }},[(_vm.locked)?_c('i',{staticClass:"el-icon-lock"}):_vm._e(),_vm._v(" "+_vm._s(_vm.statusName))])}
var staticRenderFns = []

export { render, staticRenderFns }